/**
 * Static translation dictionaries (client-only). Merge with locale from LocaleContext
 * for full i18n; for now we only ship default locale strings.
 */
import en from './en';
import de from './de';
import fr from './fr';
import es from './es';
import it from './it';
import pt from './pt';
import nl from './nl';
import no from './no';
import fi from './fi';
import da from './da';
import sv from './sv';
import ga from './ga';

const dictionaries = {
  'en-US': en,
  en,
  'de-DE': de,
  de,
  'fr-FR': fr,
  fr,
  'es-ES': es,
  es,
  'it-IT': it,
  it,
  'pt-PT': pt,
  pt,
  'nl-NL': nl,
  nl,
  'no-NO': no,
  no,
  'fi-FI': fi,
  fi,
  'da-DK': da,
  da,
  'sv-SE': sv,
  sv,
  'ga-IE': ga,
  ga,
  // English variants reuse en copy
  'en-GB': en,
  'en-AU': en,
};

export function getStaticDict(localeCode) {
  const code = localeCode && localeCode.split('-')[0];
  return dictionaries[localeCode] || dictionaries[code] || en;
}

/** Simple t(key) - key can be 'nav.categories'. Returns translated string or key. */
export function t(localeCode, key) {
  const dict = getStaticDict(localeCode);
  const parts = key.split('.');
  let v = dict;
  for (const p of parts) {
    v = v && v[p];
  }
  return typeof v === 'string' ? v : key;
}
